import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const categoryList = (params = '') => Http.get(`/wall-categories${serialize(params)}`)
export const categoryCreate = (params = '') => Http.post('/wall-categories', params)
export const categoryByID = (params = '') => Http.get(`/wall-categories/${params}`)
export const categoryUpdate = (params = '') => Http.put(`/wall-categories/${params.id}`, params)
export const categoryDestroy = (params = '') => Http.delete(`/wall-categories/${params.id}`)
